import React, { ChangeEvent, Dispatch, useEffect, useRef, useState } from 'react'
import { GroupDataRow } from '../../earlyWarning/emailComp/EmailTypes';
import { DownIcon, UpIcon } from '../../iconSet/IconSet';

export type GroupTableType = {
    id: string;
    name: string;
    description: string;
    organization: string;
    department: string;
}

type UserSelectTablePropsType = {
    groups: GroupDataRow[];
    setGroups: Dispatch<React.SetStateAction<GroupDataRow[]>>;
}

const GroupsTable = (props: UserSelectTablePropsType) => {
    const BASE_URL = process.env.REACT_APP_BASE_URL;
    const [selectedCodes, setSelectedCodes] = useState(new Set());
    const rowNumber = useRef<HTMLInputElement | null>(null)
    const searchText = useRef<HTMLInputElement | null>(null)

    const [selectedPage, setSelectedPage] = useState<number>(0)
    const [sliceCount, setSliceCount] = useState<number>(10)

    const [slicedData, setSlicedData] = useState<GroupDataRow[][]>([])

    const allGroups = useRef<GroupDataRow[]>([]);
    const [filteredData, setFilteredData] = useState<GroupDataRow[]>([]);

    const [selectedGroups, setSelectedGroups] = useState<GroupDataRow[]>([])

    // true = A -> Z
    // false = Z -> A
    const [groupNameSort, setGroupNameSort] = useState<Boolean>(true)
    const groupNameSortHandle = () => {
        setGroupNameSort(prevState => !prevState)
    }
    useEffect(() => {
        setFilteredData(prevState => {
            return [...prevState].sort((a, b) => {
                const groupNameComparison = groupNameSort ? a.groupname.localeCompare(b.groupname) : b.groupname.localeCompare(a.groupname)
                return groupNameComparison
            })
        })
    }, [groupNameSort])

    const [groupDepartmentSort, setGroupDepartmentSort] = useState<Boolean>(true)
    const groupDepartmentSortHandle = () => {
        setGroupDepartmentSort(prevState => !prevState)
    }
    useEffect(() => {
        setFilteredData(prevState => {
            return [...prevState].sort((a, b) => {
                const groupDepartmentComparison = groupDepartmentSort ? a.department.localeCompare(b.department) : b.department.localeCompare(a.department)
                return groupDepartmentComparison
            })
        })
    }, [groupDepartmentSort])

    //const [groups, setGroups] = useState<GroupTableType[]>(allData)

    useEffect(() => {
        if(props.groups.length > 0){
            setFilteredData(prevState => {
                return [...prevState].sort((a, b) => {
                    const groupNameComparison = groupNameSort ? a.groupname.localeCompare(b.groupname) : b.groupname.localeCompare(a.groupname)
                    return groupNameComparison
                })
            })
        }
    }, [props.groups])

    const paginationList = (data: GroupDataRow[], size: number): GroupDataRow[][] => {
        const result: GroupDataRow[][] = []

        if (size >= data.length) {
            return [data]
        }

        let start = 0

        while (start < data.length) {
            result.push(data.slice(start, start + size))
            start += size
        }

        return result
    }

    const paginationNavigation = (side: "next" | "prev") => {
        if (side === "next") {
            if (slicedData.length > selectedPage + 1) {
                setSelectedPage(prevState => prevState + 1)
                //console.log(">>>> good next")
            }

        } else if (side === "prev") {
            if (0 <= selectedPage - 1) {
                setSelectedPage(prevState => prevState - 1)
            }
        }
    }

    const handleSliceCountChange = (event: ChangeEvent<HTMLInputElement>) => {
        setSliceCount(event.target.valueAsNumber)
    }

    const handleSearchTextChange = (event: ChangeEvent<HTMLInputElement>) => {
        if (event.target.value === '') {
            setFilteredData(allGroups.current)
        } else {
            const query = event.target.value.toLowerCase();
            setFilteredData(allGroups.current.filter(item =>
                item.groupname.toLowerCase().includes(query) ||
                item.department.toLowerCase().includes(query)
            ));
        }
    }

    const getAllGroups = () => {
            const token = localStorage.getItem("access_token");
            fetch(BASE_URL + "/ew/api/v1/getallgroup", {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            })
                .then((res) => res.json())
                .then((data) => {
                    allGroups.current = data;
                    setFilteredData(data);
                })
                .catch((err) => console.error("Error fetching roles:", err));
        };
    
        useEffect(() => {
            getAllGroups();
        }, [])

    /* const getAllUsers = () => {
        const token = localStorage.getItem("access_token");
        fetch(BASE_URL + "/identity_manager/api/v1/getallusers", {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        })
            .then((res) => res.json())
            .then((data) => {
                allUsers.current = data;
                console.log("-------85: ", allUsers.current)
                setFilteredUserData(data);
            })
            .catch((err) => console.error("Error fetching roles:", err));
        setFilteredUserData(allData);
    }; */

    useEffect(() => {
        getAllGroups();
    }, [])

    useEffect(() => {
        const sliced = paginationList(filteredData, sliceCount);
        setSlicedData(sliced);
        setSelectedPage(0);
    }, [filteredData, sliceCount]);

    const handleGroupSelection = (group: GroupDataRow, isChecked: boolean) => {
        let updatedSelection = [];

        if (isChecked) {
            updatedSelection = [...props.groups, group];
        } else {
            updatedSelection = props.groups.filter(
                selected => selected.groupid !== group.groupid // Assuming each group has a unique `id`
            );
        }
        //console.log(updatedSelection);
        //setSelectedGroups(updatedSelection);
        props.setGroups(updatedSelection); // <-- Call the prop to set selected groups
    }

    const handleSelectAllCheckbox = (event: ChangeEvent<HTMLInputElement>) => {
        const isChecked = event.target.checked

        if (isChecked) {
            setSelectedGroups(filteredData);
            props.setGroups(filteredData);
        } else {
            setSelectedGroups([]);
            props.setGroups([]);
        }
    }

    return (
        <div style={{width: '100%'}} className='subTable-wrapper'>
            <span className='main-title'>Select Groups</span>
            <div className='field-wrapper'>
                <div className='left'>
                    <span>show <input type="number" ref={rowNumber} value={sliceCount} min={1} onChange={(e) => handleSliceCountChange(e)} /> entries</span>
                </div>
                <div className='right'>
                    <span> search <input type="text" ref={searchText} onChange={(e) => handleSearchTextChange(e)} placeholder='Search here' /></span>
                </div>
            </div>
            <div className='table-body' style={{width: '100%'}}>
                <div className='table-wrapper'>
                    <div className='table-row header' style={{ gridTemplateColumns: `4rem 15rem 1fr`, width: '100%'}}>
                        <span>
                            <input type="checkbox" className='select-all-checkbox' onChange={(e) => handleSelectAllCheckbox(e)}/>
                        </span>
                        <span onClick={(e) => groupNameSortHandle()}>
                            Name
                            <div>
                                {groupNameSort ? (
                                    <UpIcon width="1rem" color="var(--color-main-white)" />
                                ) : (
                                    <DownIcon width="1rem" color="var(--color-main-white)" />
                                )}
                            </div>
                        </span>
                        <span onClick={(e) => groupDepartmentSortHandle()}>
                            Department
                            <div>
                                {groupDepartmentSort ? (
                                    <UpIcon width="1rem" color="var(--color-main-white)" />
                                ) : (
                                    <DownIcon width="1rem" color="var(--color-main-white)" />
                                )}
                            </div>
                        </span>
                    </div>
                </div>
                {slicedData[selectedPage] && slicedData[selectedPage].map((row, index) => (
                    <div key={index} className='table-wrapper'>
                        <div className='table-row' style={{ gridTemplateColumns: `4rem 15rem 1fr`, width: '100%'}}>
                            <span style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                                <input type="checkbox" checked={props.groups.some(g => g.groupid === row.groupid)} onChange={(e) => handleGroupSelection(row, e.target.checked)}/>
                            </span>
                            <span>{row.groupname ? row.groupname : 'N/A'}</span>
                            <span style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-start'}}>{row.department}</span>
                        </div>
                    </div>
                ))}
                {filteredData.length === 0 && (
                    <div className='table-no-data-wrapper'>
                        <span>no any data available</span>
                    </div>
                )}
            </div>
            
            
            <div className='table-pagination-wrapper'>
                <div className='icon-page-box' style={{ marginBottom: "0.5rem" }} onClick={(e) => paginationNavigation("prev")}>&lt;</div>
                <div className='page-wrapper'>
                    {slicedData.map((page, index) => (
                        <span key={index} className={selectedPage === index ? 'icon-page-box selected' : 'icon-page-box'} onClick={(e) => setSelectedPage(index)}>{index + 1}</span>
                    ))}
                </div>
                <div className='icon-page-box' style={{ marginBottom: "0.5rem" }} onClick={(e) => paginationNavigation("next")}>&gt;</div>
            </div>
        </div>
    )
}

export default GroupsTable;